import React, { useState } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  Button,
  MenuItem,
  Select,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import HistoryIcon from '@mui/icons-material/History';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import { MVPFiltersProps } from '../../advanta-mvp-charts/constants';
import { MVPDataTableInternal } from '../components/table';
import CommonAppBarAdmin from '../../../components/commonAppBarAdmin';
import * as yup from 'yup';

export const materialSchema = yup.object({
  cropCode: yup.string(),
  cropName: yup.string(),
  status: yup.string(),
  division: yup.string(),
  basicMaterial: yup.string(),
  hybridName: yup.string(),
  hybridMaterialCode: yup.string(),
  hybridCommercialName: yup.string(),
  hybridProductionCode: yup.string(),
  productivityAcre: yup.string(),
  lifeOfCrop: yup.string(),
  country: yup.string(),
  season: yup.string(),
});

export const MaterialManagement: React.FC<
  MVPFiltersProps
> = ({ onNavigate, onBack }) => {
  const [status, setStatus] = useState('All Status');
  const [cultivation, setCultivation] = useState(
    'All Cultivation methods'
  );

  return (
    <div>
      {
        <CommonAppBarAdmin
          height={'auto'}
          title={'Material Management'}
          onBack={onBack}
          section={
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}>
                {/* Search */}
                <TextField
                  placeholder="Search by field number or lot number"
                  size="small"
                  variant="outlined"
                  sx={{
                    minWidth: 260,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#fafafa',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />

                <Select
                  value={status}
                  onChange={(e) =>
                    setStatus(e.target.value)
                  }
                  size="small"
                  sx={{
                    minWidth: 140,
                    backgroundColor: '#fafafa',
                    borderRadius: 2,
                  }}>
                  <MenuItem value="All Status">
                    All Status
                  </MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">
                    Inactive
                  </MenuItem>
                </Select>

                <Select
                  value={cultivation}
                  onChange={(e) =>
                    setCultivation(e.target.value)
                  }
                  size="small"
                  sx={{
                    minWidth: 190,
                    backgroundColor: '#fafafa',
                    borderRadius: 2,
                  }}>
                  <MenuItem value="All Cultivation methods">
                    All Cultivation methods
                  </MenuItem>
                  <MenuItem value="Organic">
                    Organic
                  </MenuItem>
                  <MenuItem value="Conventional">
                    Conventional
                  </MenuItem>
                </Select>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                }}>
                <Button
                  startIcon={<HistoryIcon />}
                  onClick={() =>
                    onNavigate?.('importHistory')
                  }
                  sx={{
                    textTransform: 'none',
                    color: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                  }}>
                  View History
                </Button>

                <Button
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  sx={{
                    textTransform: 'none',
                    borderColor: 'rgba(0,105,112,1)',
                    color: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                    '&:hover': {
                      borderColor: 'rgba(0,105,112,0.8)',
                      backgroundColor:
                        'rgba(0,105,112,0.05)',
                    },
                  }}>
                  Import
                </Button>

                <Button
                  startIcon={<UploadIcon />}
                  variant="contained"
                  sx={{
                    textTransform: 'none',
                    backgroundColor: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor:
                        'rgba(0,105,112,0.9)',
                    },
                  }}>
                  Export
                </Button>
              </Box>
            </>
          }
        />
      }
      <div style={{ marginTop: 80 }}></div>
      <MVPDataTableInternal type={'material'} />
    </div>
  );
};
